<template>
  <div class="footers">
    <p class="adress" v-if="langes==0">
      <span>地址：{{companyObj.companyAddress}}</span>
      <span>总机： {{companyObj.companyExtensionPhone}}、{{companyObj.companyMainPhone}}</span>
    </p>
    <p class="phone">
      
    </p>
    <p  class="copyright"> <span>版权所有©{{companyObj.copyright}}</span>
      <a href="#">技术支持</a>
        <a href="#">{{companyObj.technicalSupport}}</a>
      </p>
    <p class="technicalSupport" v-if="langes==0">
      
    </p>
    <p class="adress" v-if="langes==1">
      <span>Address: 5 / F, comprehensive office building, xiangyu'er Industrial Park, No.8, Longsheng Road, Longgang street, Longgang District, Shenzhen</span>
      <span>Switchboard 86-755-89983786, 86-755-89623778</span>
      <span>Copyright © Shenzhen WALLETT Electronic Co., Ltd</span>
    </p>
    <p class="technicalSupport" v-if="langes==1">
      <a href="#">technical support</a>
      <a href="#">Bear Clan</a>
    </p>
  </div>
</template>
<script>
export default {
  name: 'footers',
  data() {
    return {
      langes: 0,
      companyObj: {}
    }
  },
  mounted() {
    this.getCompany();
    this.langes = sessionStorage.getItem('watchStorage');
    window.addEventListener('setItem', () => {
      this.langes = sessionStorage.getItem('watchStorage');
    })
  },
  methods: {
    getCompany() {
      this.$api.get('/api/web/company_info').then(res => {
        this.companyObj = res.response;
      })
    }
  }
}
</script>
<style scoped lang="less">
.footers {
  background: #2950b8;
  color: #fff;
  height: 50px;
  padding: 20px 0;
  width: 100%;
  //margin: auto;
  //position: absolute;
 // bottom:0px;
  // left: calc(~"50% - 455px");
  .adress,
  .phone,
  .copyright,
  .technicalSupport {
    width:782px;
    margin:auto;
    margin-bottom:10px;
    span {
      margin-right: 10px;
    }
    a {
      color: #fff;
      margin-right: 20px;
    }
  }
}
</style>